import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import checkIfLoggedIn from './checkLogin';
import {
  dataById,
  deleteRecord,
  listData,
  listDataBySubId,
  listItemLocByItemId,
  saveAsRecord,
  saveRecord,
  singleQueryResult,
  tenant,
} from './tenant';
import { addErrorMessages } from './validations';
import setupReducer from './setup';
import { preferenceReducer } from './reducer_preferences';
import { currencyReducer } from './reducer_currency';
import { matrixReducer } from './reducer_matrix';
import { pricebookReducer } from './reducer_pricebook';
import { subsidiaryReducer } from './reducer_subsidiary';
import { notificationReducer } from './notificationReducer';
import { employeeReducer } from './reducer_employee';
import { reportsReducer } from './reducer_report';
import { csvReducer } from './reducer_csv';
import { dashboardReducer } from './dashboard/reducer_dashboard';
import { systemNotesReducer } from './reducer_system_notes';
import listTableReducer from './reducer_list_table';
import userReducer from './reducer_user';
import translationReducer from './reducer_translation';
import feathersClientReducer from 'ks-feathers-client/reducers';
import modalReducer from './reducer_modal';
import { pathReducer } from './reducer_path';
import { simpleFormReducer } from './reducer_form_simple';
import downloaderReducer from './reducer_downloader';
import { purchaseReducer } from './reducer_purchase';
import { inventoryReducer } from './reducer_inventory';
import { itemLocationReducer } from './reducer_item_location';
import { itemUomReducer } from './reducer_item_uom';
import { recordReducer } from './reducer_record';
import globalSearchReducer from './reducer_global_search';
import csvExport from './reducer_csv_export';
import storeSummaryReducer from './reducer_store_summary';
import pdfPreviewReducer from './reducer_pdf_preview';
import { saleTransactionReducer } from './reducer_sale_transaction';

import hotkeyTemplateReducer from '../components/admin/hotkey_template/reducers';
import tyroReducer from '../tyro/reducer';
import dropdownReducer from '../components/common/form/fields/dropdown_search/reducer';
import addressSearchReducer from '../components/common/form/fields/address_search/AddressSearchFieldReducer';
import userPermissions from './reducer_permissions';
import intlReducer from './reducer_intl';
import listReducer from './reducer_list';
import integrationReducer from './integration/reducer_integration';

import { entityPurchaseReducer } from './reducer_entity_purchase';

import sectionTableReducer from '../components/common/form/SectionTable/reducer';

import { customFormReducer } from './reducer_custom_form';
import { labelPrintReducer } from './reducer_label_print';
import { omsReducer } from './oms/reducer_oms';
import { progressSegmentReducer } from './reducer_progress';

const appReducer = combineReducers({
  form: formReducer,
  tyro: tyroReducer,
  hotkey_template: hotkeyTemplateReducer,
  checkIfLoggedIn,
  routing: routerReducer,
  tenant: tenant,
  path: pathReducer,
  listData: listData,
  listTable: listTableReducer,
  lists: listReducer,
  dataById: dataById,
  listDataBySubId: listDataBySubId,
  saveRecord: saveRecord,
  saveAsRecord: saveAsRecord,
  listItemLocByItemId: listItemLocByItemId,
  deleteRecord: deleteRecord,
  addErrorMessages: addErrorMessages,
  setup: setupReducer,
  preference: preferenceReducer,
  currency: currencyReducer,
  matrix: matrixReducer,
  hasTransaction: singleQueryResult,
  pricebook: pricebookReducer,
  translation: translationReducer,
  csv: csvReducer,
  csv_export: csvExport,
  notifications: notificationReducer,
  employee: employeeReducer,
  item_location: itemLocationReducer,
  item_uom: itemUomReducer,
  inventory: inventoryReducer,
  user: userReducer,
  report: reportsReducer,
  app: feathersClientReducer,
  modals: modalReducer,
  dropdown: dropdownReducer,
  dashboard: dashboardReducer,
  subsidiary: subsidiaryReducer,
  system_notes: systemNotesReducer,
  downloader: downloaderReducer,
  purchase : purchaseReducer,
  permissions: userPermissions,
  intl: intlReducer,
  global_search: globalSearchReducer,
  record: recordReducer,
  store_summary: storeSummaryReducer,
  simpleform: simpleFormReducer,  
  entity_purchase : entityPurchaseReducer,
  section_table: sectionTableReducer,
  address_search: addressSearchReducer,
  custom_form: customFormReducer,
  pdf_preview: pdfPreviewReducer,
  label_print: labelPrintReducer,
  integration: integrationReducer,
  oms: omsReducer,
  progress: progressSegmentReducer,
  sale_transaction: saleTransactionReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
